import { useEffect, useRef, useState } from "react";
import { call, register, remove } from "../funcStore";
import { ATTRIBUTE_LABELS } from "../data/mockVtubers";

const styles = {
  tagList: {
    listStyle: "none",
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    padding: 0,
    margin: 0,
  },
  tag: {
    background: "#eee",
    border: "none",
    borderRadius: "12px",
    padding: "2px 10px",
    fontSize: "0.85rem",
  },
  tagUnapproved: {
    opacity: 0.4,
  },
};

const STATE_BEFORE_INIT = "beforeInit";
const STATE_DISPLAY = "display";

function TagList({ parentKey }) {
  const [state, setState] = useState(STATE_BEFORE_INIT);

  const stateRef = useRef(state);
  stateRef.current = state;

  const funcKeyRef = useRef(`${parentKey}.tagList`);
  const funcKey = funcKeyRef.current;

  const dataRef = useRef({
    attributes: [],
  });

  const sync = () => {
    dataRef.current.attributes = call(`${parentKey}.getAttributes`) || [];
  };

  const init = () => {
    sync();

    register(`${funcKey}.getState`, () => stateRef.current);

    register(`${funcKey}.getAttributes`, () => dataRef.current.attributes);

    register(`${funcKey}.refresh`, () => {
      sync();
      setState(STATE_DISPLAY);
    });

    setState(STATE_DISPLAY);
  };

  useEffect(() => {
    if (state === STATE_BEFORE_INIT) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    return () => {
      remove(`${funcKey}.getState`);
      remove(`${funcKey}.getAttributes`);
      remove(`${funcKey}.refresh`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state === STATE_BEFORE_INIT) {
    return null;
  }

  const handleTagClick = (value) => {
    call(`${parentKey}.tagClick`, value);
  };

  return (
    <ul style={styles.tagList}>
      {dataRef.current.attributes
        .filter((attribute) => ATTRIBUTE_LABELS[attribute.value])
        .map((attribute) => (
          <li key={attribute.value}>
            <button
              type="button"
              style={
                attribute.approved
                  ? styles.tag
                  : { ...styles.tag, ...styles.tagUnapproved }
              }
              onClick={() => handleTagClick(attribute.value)}
            >
              {ATTRIBUTE_LABELS[attribute.value]}
            </button>
          </li>
        ))}
    </ul>
  );
}

export default TagList;
